<template>
  <p style="display:block;height:25px;line-height:25px;color:#aaa;">
    <span style="background:#3b5998;color:white;float:right;padding:0 10px">
      <!-- <Icon type="social-facebook"></Icon> Share -->
      <social-sharing :url="shareURL"
        :title="this.item.title"
        :description="shareDesc"
        inline-template>
        <div>
            <network network="facebook">
              <span style="background:#3b5998;color:white;padding:0 10px">
                <Icon type="social-facebook"></Icon> Share
              </span>
            </network>
        </div>
      </social-sharing>
    </span>
    <!-- <Avatar :src="sImg" size="small"></Avatar> Please share this post -->
  </p>
</template>

<script>
import Utils from '@/utils.js';
import dImg from '@/assets/tapang-outline.png';

export default {
  name: 'SharePost',
  data() {
    return {
      sImg: dImg
    }
  },
  props: {
    item: {
      required: true,
      type: Object
    }
  },
  computed: {
    shareURL() {
      return this.item.data.page_url //`${process.env.VUE_APP_SITE}/${process.env.VUE_APP_DEV_ECOSYSTEM}/feed/${this.item.id}`;
    },
    shareImg() {
      return this.item.cover_photo[0].original;
    },
    shareDesc() {
      return this.contentDisplay(this.item).replace(/<\/?[^>]+(>|$)/g, '');
    }
  },
  mounted() {
    this.eventEmitter();
    this.$root.$on('social_shares_open', function (network, url) {
      // your event code
      console.log(network, url)
      console.log('test')
    });
  },
  methods: {
    eventEmitter() {
      BroadcastEvent.$on('onSharing',() => {
        console.log('onSharing...');
        this.sharepost();
      });
    },
    contentDisplay (act) {
      switch (act.type) {
        case 'user_post':
          if (act.data) return act.data.text
          break;
        case 'passport_expiration':
          return 'Passport Expiration'
        case 'contract_expiration':
          return 'Contract Expiration'
        case 'attachment':
          if (act.data) {
            switch (act.data.attachment_type) {
              case 'video':
                if (act.data.text || act.data.preview_summary) { return act.data.text || act.data.preview_summary }
                break
              case 'link':
                if (act.data.text || act.data.preview_summary) { return act.data.text || act.data.preview_summary }
                break
              default:
                if (act.data.text) return act.data.text
                break
            }
          }
          break
        case 'trivia':
          if (act.data && act.data.question) return act.data.question
          break
        case 'reveal':
          if (act.data && act.data.question) return act.data.question
          break
        case 'recipe':
          if (act.data && act.data.description) { return act.data.description }
          break
        case 'video': 
          if (act.data && act.data.text) { return act.data.text }
          break
        default:
          if (act.data && act.data.tip) { return act.data.tip }
          break
      }
      return ''
    },
    sharepost () {
      let desc = this.contentDisplay(this.item).replace(/<\/?[^>]+(>|$)/g, '')
      let img = this.item.cover_photo[0].original
      
      Utils.triggerShare(
        this.shareURL,
        this.item.title,
        img,
        desc
      )

    }
  }
}
</script>
